var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('detail-bootcamp-mobile'):_c('detail-bootcamp-dekstop')
}
var staticRenderFns = []

export { render, staticRenderFns }